// src/config/demoConfig.js

// Noms des modes utilisés dans l’app
export const SITE_MODE_DEMO = "demo";
export const SITE_MODE_MAIRIE = "mairie";

// Valeur par défaut (compile-time) depuis le .env
// REACT_APP_SITE_MODE=demo  ou  REACT_APP_SITE_MODE=mairie (ou classic)
const envDefault = String(process.env.REACT_APP_SITE_MODE || SITE_MODE_DEMO)
  .toLowerCase()
  .trim();

// On tolère encore "classic" pour compatibilité
export const DEFAULT_SITE_MODE =
  envDefault === "mairie" || envDefault === "classic"
    ? SITE_MODE_MAIRIE
    : SITE_MODE_DEMO;
